<app-navigation-layout [hideHeader]='true'>
  <span main-container>
    <app-time-slot-simple-list *ngIf="showTimeSlotSimpleList"></app-time-slot-simple-list>
    <app-ticket-configurator #ticketConfigurator></app-ticket-configurator>
  </span>
  <span menu-container>
    <app-booking-basket-simple-view></app-booking-basket-simple-view>
  </span>
  <span navigation-container>
    <app-backward-forward (backwardClick)="onBackwardClick()" (forwardClick)="onForwardClick()"
      [forwardError]="forwardError"></app-backward-forward>
  </span>
</app-navigation-layout>
